import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
var routerArr = []
console.log(window.screen.width);
if (window.screen.width < 500) {
	routerArr = [{
			// 首页
			path: '/',
			component: () => import('@/views/api/index'),
			hidden: true,
      meta:{
        title:'川崎电气(杭州)有限公司'
      }
		},
		{ //新闻资讯
			path: '/news',
			component: () => import('@/views/api/news'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //联系我们
			path: '/contact',
			component: () => import('@/views/api/contact'),
			hidden: true,
      meta:{
        title:'日本川崎五金集团'
      }
		},
		{ //旗下品牌
			path: '/brands',
			component: () => import('@/views/api/brands'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //商品详情
			path: '/goodsDetile',
			component: () => import('@/views/api/products/goodsDetile'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //咨询详情
			path: '/newsDetile',
			component: () => import('@/views/api/products/newsDetile'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //平开门五金系统
			path: '/SwingDoor',
		 component: () => import('@/views/api/products/SwingDoor'),
			hidden: true,
      meta:{
        title:'日本川崎家居五金'
      }
		},
		{ //工艺介绍
			path: '/technology',
			component: () => import('@/views/api/products/technology'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //公司介绍
			path: '/about',
			component: () => import('@/views/api/products/about'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
    { //分类
    	path: '/classList',
    	component: () => import('@/views/api/products/classList'),
    	hidden: true,
      meta:{
        title:'日本川崎五金'
      }
    },
	]
} else {
	routerArr = [{
			path: '/',
			name: 'index',
			component: () => import('@/views/pc/index'),
			hidden: true,
      meta:{
        title:'川崎电气(杭州)有限公司'
      }
		},
		{ //新闻资讯
			path: '/news',
			component: () => import('@/views/pc/news'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //联系我们
			path: '/contact',
			component: () => import('@/views/pc/contact'),
			hidden: true,
      meta:{
        title:'日本川崎五金集团'
      }
		},
		{ //旗下品牌
			path: '/brands',
			component: () => import('@/views/pc/brands'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //功能门系统
			path: '/goodsDetile',
			component: () => import('@/views/pc/products/goodsDetile'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //移门系统
			path: '/newsDetile',
			component: () => import('@/views/pc/products/newsDetile'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //平开门五金系统
			path: '/SwingDoor',
			component: () => import('@/views/pc/products/SwingDoor'),
			hidden: true,
      meta:{
        title:'日本川崎家居五金'
      }
		},
		{ //工艺介绍
			path: '/technology',
			component: () => import('@/views/pc/products/technology'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
		{ //工艺介绍
			path: '/about',
			component: () => import('@/views/pc/products/about'),
			hidden: true,
      meta:{
        title:'日本川崎五金'
      }
		},
    { //分类
    	path: '/classList',
    	component: () => import('@/views/pc/products/classList'),
    	hidden: true,
      meta:{
        title:'日本川崎五金'
      }
    },
	]
}
export var constantRoutes = routerArr




const createRouter = () => new Router({
	mode: 'history', // require service support
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRoutes
})

const router = createRouter()




export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // reset router
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js